import { useState, useEffect } from 'react'
import { Card } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom'
import * as subcategoriaService from '../servicios/subcategoriaService'

const Subcategorias = () => {
  const { idCategoria, descripcion } = useParams()
  const [subCategorias, setSubCategorias] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      const { data: subCategorias } =
        await subcategoriaService.buscarTodosPorIdCategoria(idCategoria)
      setSubCategorias(subCategorias)
    }

    fetchData()
  }, [idCategoria])

  return (
    <>
      <div className="mb-4 text-center"></div>
      <h2 className="mb-5">{descripcion}</h2>
      <div className="row">
        {subCategorias.map((e) => (
          <div key={e.idSubCategoria} className="col-3">
            <Link
              to={
                e.tieneSubCategoria === 0
                  ? `/Publicaciones/Subcategorias/${e.idSubCategoria}`
                  : `/SubCategorias/${e.idSubCategoria}/${e.descripcion}`
              }
            >
              <Card className="mb-2" style={{ width: '15rem' }}>
                <Card.Img variant="top" />
                <Card.Body>
                  <Card.Title className="pt-1 f-size-15" name={e.descripcion}>
                    {e.descripcion}
                  </Card.Title>
                </Card.Body>
              </Card>
            </Link>
          </div>
        ))}
      </div>
    </>
  )
}

export default Subcategorias
